import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Grid
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const QuantitySelectorPopup = (props) => {
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if(props.initialQuantity!=undefined){setQuantity(props.initialQuantity);}
  }, [props.initialQuantity]);

  const handleQuantityChange = (value) => {
    if (value >= 1 && value <= 100) {
      setQuantity(value);
    }
  };

  const handleSave = () => {
    props.onSave(quantity);
  };

  console.log(props);

  return (
    <Dialog open onClose={props.handleClose} maxWidth="sm" fullWidth={true}>
      <DialogContent>
        <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'30px', marginBottom:'30px'}}><Typography  style={{textAlign:'center'}}>{props.explanation}</Typography></div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', width: '120px' }}>
            <IconButton onClick={() => handleQuantityChange(quantity - 1)} disabled={quantity <= 1}>
              <RemoveIcon />
            </IconButton>
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{quantity}</span>
            <IconButton onClick={() => handleQuantityChange(quantity + 1)}>
              <AddIcon />
            </IconButton>
          </div>
          <Grid container style={{marginBottom:'30px', width:'calc(100% + 60px)'}}>
            <Grid item xs={6}><Typography style={{textAlign:'center'}}><b>Total Cost:</b> {props.currency}{quantity*props.cost_per_unit}</Typography></Grid>
            <Grid item xs={6}><Typography style={{textAlign:'center'}}><b>Credits:</b>{props.credits_icon}{quantity*props.credits_per_unit}</Typography></Grid>
          </Grid>
          <Button onClick={handleSave} color="primary" variant="contained">
            Confirm
          </Button>

        </div>
        <div style={{height:'40px'}}/>
      </DialogContent>
    </Dialog>
  );
};

export default QuantitySelectorPopup;
